import { render } from "./ParticipantsIcon.vue?vue&type=template&id=5e036fe9"
import script from "./ParticipantsIcon.vue?vue&type=script&lang=js"
export * from "./ParticipantsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__